import { useMutation } from '@tanstack/react-query';
import saveAs from 'file-saver';

import { constants } from '../constants';
import { getFreshTokens } from '../services/network/Api';
import { APIError } from '../services/network/types';
import { t } from '../services/translation/translation';

const downloadInvoice = async (tripKey: string) => {
  const tokens = await getFreshTokens();
  const response = await fetch(`${constants.passengerApi}/trip/v1/invoice?tripKey=${tripKey}`, {
    method: 'GET',
    headers: {
      responseType: 'blob',
      ...(tokens ? { Authorization: `Bearer ${tokens.accessToken}` } : {}),
    },
  });

  if (!response.ok) {
    throw { type: 'api', message: t('network.server-error') } satisfies APIError;
  }

  const blob = await response.blob();

  // Download the file
  saveAs(blob, `${tripKey}.pdf`);
};

export const useDownloadInvoice = () =>
  useMutation({
    mutationFn: downloadInvoice,
  });
